import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Route, Router } from "@angular/router";
import { TranslocoService } from "@jsverse/transloco";
import { RestService } from "@stdoutsrl/design-kit"
import {  Message } from "@stdoutsrl/design-kit";
import { LoaderService } from "../../service/loader.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styles: [],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  constructor(
    private router: Router,
    private rest: RestService,
    private loader: LoaderService,
    private message: Message,
    private activatedRoute: ActivatedRoute,
    private transloco: TranslocoService
  ) {}

  currentLangIcon = 0
  showLang = false
  user = (JSON.parse(localStorage.getItem('user') ?? '{}'))?.user

 ngOnInit(): void {
    switch (this.transloco.getActiveLang()) {
      case 'it':
        this.currentLangIcon = 0
        break;
      case 'en':
        this.currentLangIcon = 1
        break;
      case 'de':
        this.currentLangIcon = 2
        break;
      case 'es':
        this.currentLangIcon = 3
        break;
      case 'fr':
        this.currentLangIcon = 4
        break;

      default:
        break;
    }
  }

  changeLang(lang: string) {
    localStorage.setItem("language", JSON.stringify({ value: lang }))
    this.transloco.setActiveLang(lang)
    this.showLang = false
    window.location.replace('')
  }

  logout(){
    localStorage.clear()
    window.location.reload()
  }

  goTo(path:string){
    this.router.navigate([path])
  }
}
